<div class="flex h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full">
        <div>
            <!-- <img class="mx-auto h-12 w-auto" src="/img/logos/workflow-mark-on-white.svg" alt="Workflow" /> -->
            <h2 class="text-center text-3xl leading-9 font-extrabold text-blue-500">
                <span class="text-yellow-400"> Change </span> your password
            </h2>
            <!-- <p class="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
          Or
          <a href="#" class="font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150">
            start your 14-day free trial
          </a>
        </p> -->
        </div>
        <form [formGroup]="form" class="mt-8" (submit)="onSubmit()">
            <input type="hidden" name="remember" value="true" />

            <div class="rounded-md shadow-sm">
                <input formControlName="oldPassword" aria-label="Old Password" name="oldPassword" type="password" required
                    class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                    placeholder="Old password" />
            </div>

            <div class="rounded-md shadow-sm mt-4">
                <input formControlName="newPassword" aria-label="New Password" name="newPassword" type="password" required
                    class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                    placeholder="New password" />
            </div>

            <div class="rounded-md shadow-sm mt-4">
                <input formControlName="newPasswordRetype" aria-label="Retype New Password" name="password" type="password" required
                    class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                    placeholder="New password retype" />
            </div>

            <p [class.text-red-600]="form.controls.newPassword.errors?.pattern && form.controls.newPassword.touched"
                class="mt-2 text-xs text-gray-400">Password must be between 8 to 32 characters with at least 1
                uppercase, 1 lower case and 1 number.</p>

            <p *ngIf="form.controls.newPasswordRetype.errors?.mustMatch" class="mt-2 text-xs text-red-600">Password not
                Match</p>

            <p *ngIf="form.controls.oldPassword.errors?.mustNotMatch" class="mt-2 text-xs text-red-600">Old Password can not be the same as the new password</p>


            <div class="flex items-center justify-between mt-4">
                <div class="flex items-center">

                </div>

                <!-- <div class="text-sm">
            <a [routerLink]="['../request-reset']" class="font-medium text-blue-600 hover:text-blue-500">
              Forgot your password?
            </a>
          </div> -->
            </div>

            <div class="mt-6">
                <button type="submit" [disabled]="form.invalid" [class.opacity-50]="form.invalid"
                    [class.hover:bg-blue-400]="form.valid"
                    class="group relative w-full  flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-500 focus:outline-none focus:border-blue-600 focus:ring-blue active:bg-blue-600 transition duration-150 ease-in-out">
                    <span class="absolute left-0 inset-y pl-3">
                        <svg class="h-5 w-5 text-blue-500 group-hover:text-blue-400 transition ease-in-out duration-150"
                            fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                   Save
                </button>
            </div>



        </form>

        <!-- <button (click)="testApollo()" type="submit" class="mt-4 relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-400 focus:outline-none focus:border-blue-600 focus:ring-blue active:bg-blue-600 transition duration-150 ease-in-out">
        <span class="absolute left-0 inset-y pl-3">
          <svg class="h-5 w-5 text-blue-500 group-hover:text-blue-400 transition ease-in-out duration-150" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
          </svg>
        </span>
        Test Apollo Link
      </button> -->
    </div>
</div>